/**
 * Translations for the "Me" feature area (MePage profile screen).
 * Keep zh and en in lock-step.
 */
const me = {
  zh: {
    'me.page.title': '⚙️ 设置',
    'me.page.subtitle': '语言、声音、提醒和账号',
    'me.umbrella.title': '我',
    'me.umbrella.subtitle': '钱包、故事、信箱、设置都在这儿',
    'me.section.wallet.title': '钱包',
    'me.section.wallet.helper': '余额、收支、攒钱目标',
    'me.section.story.title': '我们的故事',
    'me.section.story.helper': '时光轴回看一起做过的事',
    'me.section.mailbox.title': '信箱',
    'me.section.mailbox.helper': '看看爸爸妈妈写来的信',
    'me.section.invite.title': '邀请好友',
    'me.section.invite.helper': '把小陪伴推荐给朋友',
    'me.section.pokedex.title': '图鉴',
    'me.section.pokedex.helper': '我认识的所有小动物',
    'me.section.settings.title': '设置',
    'me.section.settings.helper': '语言、声音、提醒、退出',
    'me.avatar.fallback': '👶',
    'me.profile.title': '账号档案',
    'me.profile.helper': '当前孩子账号和金币概览',
    'me.profile.editName.title': '修改名字',
    'me.profile.editName.helper': '这里改的是游戏里显示的名字，登录名不会改变',
    'me.profile.editName.label': '显示名字',
    'me.profile.editName.placeholder': '输入 1-20 个字符',
    'me.profile.editName.save': '保存名字',
    'me.profile.editName.saved': '已保存',
    'me.profile.editName.error': '名字没有保存成功，稍后再试',
    'me.loginName.label': '登录名：{name}',
    'me.createdAt': '账号创建于 {date}',
    'me.balance.label': '当前金币',
    'me.content.title': '年龄匹配',
    'me.content.helper': '题目、聊天语气和小游戏会按年龄调整',
    'me.content.birth': '生日',
    'me.content.age': '年龄',
    'me.content.ageValue': '{age} 岁',
    'me.content.tier': '内容档',
    'me.content.unknown': '未设置',
    'me.content.parentNote': '生日和年龄由家长后台管理，孩子端只显示当前适配结果。',
    'me.tier.little': '学龄前 (3-5)',
    'me.tier.young': '小学低年级 (6-8)',
    'me.tier.older': '小学高年级 (9-11)',
    'me.tier.tween': '初中 (12-14)',
    'me.lang.title': '语言',
    'me.lang.helper': '选择游戏界面和宠物对话语言',
    'me.lang.locked': '家长已锁定为 {lang}',
    'me.lang.option.zh': '中文',
    'me.lang.option.en': 'English',
    'me.audio.title': '声音',
    'me.audio.helper': '控制背景音乐和音乐风格',
    'me.audio.musicOn': '背景音乐：开',
    'me.audio.musicOff': '背景音乐：关',
    'me.push.title': '提醒',
    'me.push.ready': '提醒已开启，重要消息会通过设备通知送达。',
    'me.push.prompt': '开启后可以收到奖励、宠物和任务提醒。',
    'me.push.denied': '浏览器已拒绝提醒，需要到系统或浏览器设置中重新允许。',
    'me.push.unsupported': '当前浏览器不支持网页提醒。',
    'me.push.not_configured': '服务端提醒密钥还没配置，暂时不能开启。',
    'me.push.enabling': '正在开启提醒...',
    'me.push.enable': '开启提醒',
    'me.push.readyButton': '提醒已开启',
    'me.links.title': '常用入口',
    'me.links.helper': '快速查看金币、宠物和小游戏',
    'me.links.wallet': '金库与金币动态',
    'me.links.invite': '邀请好友',
    'me.links.pet': '宠物档案',
    'me.links.games': '小游戏',
    'me.logout': '退出登录',
    'invite.page.title': '🎁 邀请好友',
    'invite.page.subtitle': '把小陪伴分享给朋友，成功后一起拿奖励',
    'invite.hero.title': '你的邀请码',
    'invite.hero.body': '朋友用你的链接注册家长账号，并且 TA 的孩子第一次登录后，你可以获得 {childReward} 金币。新家长注册成功会获得 {parentReward} 金币欢迎奖励。',
    'invite.stat.invited': '已邀请家庭',
    'invite.stat.earned': '已获得奖励',
    'invite.code.label': '邀请码',
    'invite.copyCode': '复制邀请码',
    'invite.copyLink': '复制链接',
    'invite.share.button': '用系统分享发给好友',
    'invite.share.title': '小陪伴邀请',
    'invite.share.text': '{name} 邀请你加入小陪伴。注册时使用邀请码 {code}，家长会获得欢迎金币奖励。',
    'invite.rules.title': '奖励规则',
    'invite.rules.parent': '朋友通过你的链接注册家长账号后，会先获得 1000 金币欢迎奖励。',
    'invite.rules.child': '对方孩子第一次登录小陪伴后，系统确认邀请成功。',
    'invite.rules.reward': '确认成功后，你会获得 500 金币邀请奖励。',
    'invite.toast.linkCopied': '邀请链接已复制 ✅',
    'invite.toast.codeCopied': '邀请码已复制 ✅',
    'invite.toast.copyFailed': '复制失败，请手动选中文字复制',
    'invite.toast.loadFailed': '邀请码加载失败，稍后再试',
    'profile.page.title': '👑 园长档案',
    'profile.page.subtitle': '动物乐园等级、金币和成长记录',
    'profile.summary.title': '账户概要',
    'profile.rank.title': '园长等级',
    'profile.growth.title': '成长记录',
    'profile.growth.playDays': '园长活跃天数',
    'profile.growth.careDays': '照顾动物天数',
    'profile.growth.petCount': '动物数量',
    'profile.growth.completedTasks': '完成任务/小任务',
    'profile.growth.mail': '未读信箱',
    'profile.growth.activePet': '当前宠物',
    'profile.growth.noPet': '还没有宠物',
    'profile.created': '创建时间',
    'profile.links.wallet': '金库',
    'profile.links.timeline': '成长故事',
    'profile.links.mailbox': '信箱',
    'profile.links.pet': '宠物档案',
    'profile.settings': '编辑设置',
  },
  en: {
    'me.page.title': '⚙️ Settings',
    'me.page.subtitle': 'Language, sound, alerts, and account',
    'me.umbrella.title': 'Me',
    'me.umbrella.subtitle': 'Wallet, story, mailbox, and settings — all here',
    'me.section.wallet.title': 'Wallet',
    'me.section.wallet.helper': 'Balance, activity, savings goals',
    'me.section.story.title': 'Our Story',
    'me.section.story.helper': 'Timeline of everything we did together',
    'me.section.mailbox.title': 'Mailbox',
    'me.section.mailbox.helper': 'Read what mum and dad wrote',
    'me.section.invite.title': 'Invite friends',
    'me.section.invite.helper': 'Share Xiaopeiban with friends',
    'me.section.pokedex.title': 'Pokédex',
    'me.section.pokedex.helper': 'Every animal I have met',
    'me.section.settings.title': 'Settings',
    'me.section.settings.helper': 'Language, sound, alerts, log out',
    'me.avatar.fallback': '👶',
    'me.profile.title': 'Account',
    'me.profile.helper': 'Current child account and coin overview',
    'me.profile.editName.title': 'Change name',
    'me.profile.editName.helper': 'This changes the in-game display name, not the login name',
    'me.profile.editName.label': 'Display name',
    'me.profile.editName.placeholder': 'Enter 1-20 characters',
    'me.profile.editName.save': 'Save name',
    'me.profile.editName.saved': 'Saved',
    'me.profile.editName.error': 'Name was not saved. Try again soon',
    'me.loginName.label': 'Login name: {name}',
    'me.createdAt': 'Joined on {date}',
    'me.balance.label': 'Current coins',
    'me.content.title': 'Age fit',
    'me.content.helper': 'Quizzes, pet tone, and mini games adapt by age',
    'me.content.birth': 'Birthday',
    'me.content.age': 'Age',
    'me.content.ageValue': '{age} years old',
    'me.content.tier': 'Content tier',
    'me.content.unknown': 'Not set',
    'me.content.parentNote': 'Birthday and age are managed by parents. This page shows the current content fit.',
    'me.tier.little': 'Preschool (3-5)',
    'me.tier.young': 'Lower primary (6-8)',
    'me.tier.older': 'Upper primary (9-11)',
    'me.tier.tween': 'Early secondary (12-14)',
    'me.lang.title': 'Language',
    'me.lang.helper': 'Choose the game UI and pet chat language',
    'me.lang.locked': 'Locked by parent: {lang}',
    'me.lang.option.zh': '中文',
    'me.lang.option.en': 'English',
    'me.audio.title': 'Sound',
    'me.audio.helper': 'Control background music and music style',
    'me.audio.musicOn': 'Background music: on',
    'me.audio.musicOff': 'Background music: off',
    'me.push.title': 'Alerts',
    'me.push.ready': 'Alerts are on. Important updates will be sent to this device.',
    'me.push.prompt': 'Turn on alerts for rewards, pet, and mission reminders.',
    'me.push.denied': 'Alerts are blocked. Re-enable them in browser or system settings.',
    'me.push.unsupported': 'This browser does not support web alerts.',
    'me.push.not_configured': 'Server push keys are not configured yet.',
    'me.push.enabling': 'Turning alerts on...',
    'me.push.enable': 'Turn on alerts',
    'me.push.readyButton': 'Alerts on',
    'me.links.title': 'Shortcuts',
    'me.links.helper': 'Jump to coins, pet, and mini games',
    'me.links.wallet': 'Vault and coin activity',
    'me.links.invite': 'Invite friends',
    'me.links.pet': 'Pet profile',
    'me.links.games': 'Mini games',
    'me.logout': 'Log out',
    'invite.page.title': '🎁 Invite friends',
    'invite.page.subtitle': 'Share Little Companion and earn rewards together',
    'invite.hero.title': 'Your invite code',
    'invite.hero.body': 'When a friend registers a parent account through your link and their child logs in for the first time, you earn {childReward} coins. New parents receive a {parentReward}-coin welcome bonus.',
    'invite.stat.invited': 'Families invited',
    'invite.stat.earned': 'Rewards earned',
    'invite.code.label': 'Invite code',
    'invite.copyCode': 'Copy code',
    'invite.copyLink': 'Copy link',
    'invite.share.button': 'Share with system sheet',
    'invite.share.title': 'Little Companion invite',
    'invite.share.text': '{name} invited you to Little Companion. Use invite code {code} at sign-up to get welcome coins.',
    'invite.rules.title': 'Reward rules',
    'invite.rules.parent': 'A friend gets 1000 welcome coins after registering a parent account through your link.',
    'invite.rules.child': 'The invite is confirmed when that family’s child first logs in.',
    'invite.rules.reward': 'After confirmation, you receive a 500-coin invite reward.',
    'invite.toast.linkCopied': 'Invite link copied ✅',
    'invite.toast.codeCopied': 'Invite code copied ✅',
    'invite.toast.copyFailed': 'Copy failed. Please copy manually.',
    'invite.toast.loadFailed': 'Could not load invite code. Try again later.',
    'profile.page.title': '👑 Keeper Profile',
    'profile.page.subtitle': 'Animal park level, coins, and growth record',
    'profile.summary.title': 'Account summary',
    'profile.rank.title': 'Keeper level',
    'profile.growth.title': 'Growth record',
    'profile.growth.playDays': 'Keeper active days',
    'profile.growth.careDays': 'Pet-care days',
    'profile.growth.petCount': 'Animals owned',
    'profile.growth.completedTasks': 'Tasks/small tasks done',
    'profile.growth.mail': 'Unread mail',
    'profile.growth.activePet': 'Active pet',
    'profile.growth.noPet': 'No pet yet',
    'profile.created': 'Created',
    'profile.links.wallet': 'Vault',
    'profile.links.timeline': 'Growth story',
    'profile.links.mailbox': 'Mailbox',
    'profile.links.pet': 'Pet profile',
    'profile.settings': 'Edit settings',
  },
};

export default me;
